import type { PlatformLogoProps } from './types'
import LogoSvg from '../../assets/platform-logos/ebay.svg?react'
import { chakra } from '../../chakra'
import { getLogoProps } from './use-logo-props'
import * as React from 'react'

const Logo = chakra(LogoSvg)

export const EbayLogo = React.forwardRef<SVGSVGElement, PlatformLogoProps>(
  function EbayLogo(props, ref) {
    const logoProps = getLogoProps(props)

    return <Logo {...logoProps} ref={ref} />
  },
)
